import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ICategory, IVoucher, VoucherOrderUsage } from '@app/data-interfaces';
import { VoucherService } from '@app/shared/data-vouchers';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-voucher-detail',
  templateUrl: './voucher-detail.component.html',
  styleUrls: ['./voucher-detail.component.scss'],
})
export class VoucherDetailComponent implements OnInit {
  voucher$?: Observable<Partial<IVoucher>>;
  orderUsages: VoucherOrderUsage[] = [];
  loading = false;
  loadingOrderUsages = false;
  showOrderUsages = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private voucherService: VoucherService,
  ) {
    this.route.params.subscribe((params: any) => {
      this.showOrderUsages = false;
      this.loadingOrderUsages = false;
      this.orderUsages = [];
      if (params['id'] !== 'new') {
        this.voucher$ = this.voucherService.getVoucher(
          params['id'],
        ) as Observable<ICategory>;
      } else {
        this.voucher$ = of({
          code: '',
          value: 0,
          speciel_rules: {},
          maximum_uses: 1,
          use_count: 0,
          type: 'value',
        });
      }
    });
  }

  ngOnInit(): void {}

  toggleOrderUsages(voucher: Partial<IVoucher>): void {
    this.showOrderUsages = !this.showOrderUsages;
    if (this.showOrderUsages) {
      this.loadOrderUsages(voucher);
    }
  }

  private loadOrderUsages(voucher: Partial<IVoucher>): void {
    if (!voucher.code) {
      this.orderUsages = [];
      return;
    }

    this.loadingOrderUsages = true;
    this.voucherService.getOrdersByVoucherCode(voucher.code).subscribe({
      next: (orders) => {
        this.loadingOrderUsages = false;
        this.orderUsages = orders;
      },
      error: () => {
        this.loadingOrderUsages = false;
        this.orderUsages = [];
      },
    });
  }

  saveVoucher(voucher: Partial<IVoucher>): void {
    this.loading = true;
    this.voucherService.upsertVoucher(voucher).subscribe(() => {
      this.loading = false;
      this.router.navigateByUrl('vouchers');
    });
  }

  deleteVoucher(voucher: Partial<IVoucher>) {
    let result = confirm('Wollen Sie den Gutschein wirklich löschen?');
    if (result && voucher.id) {
      this.voucherService.deleteVoucher(voucher).subscribe(() => {
        this.router.navigateByUrl('vouchers');
      });
    }
  }
}
